import { render, staticRenderFns } from "./repair-change.vue?vue&type=template&id=4f5bd18f&"
import script from "./repair-change.vue?vue&type=script&lang=js&"
export * from "./repair-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports